import { render, staticRenderFns } from "./ho_user_allocation_list.vue?vue&type=template&id=6f8c2f76&scoped=true"
import script from "./ho_user_allocation_list.vue?vue&type=script&lang=js"
export * from "./ho_user_allocation_list.vue?vue&type=script&lang=js"
import style0 from "./ho_user_allocation_list.vue?vue&type=style&index=0&id=6f8c2f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8c2f76",
  null
  
)

/* custom blocks */
import block0 from "./ho_user_allocation_list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports